import { createGlobalStyle, css } from "styled-components";

// When a modal (repeat or cancel) is opened on top of the betsModal and later closed,
// it restores the body's scrolling capability. This ensures that while betsModal modal is open,
// scrolling is disabled to prevent any interference.
export const GlobalStyle = createGlobalStyle<{ isOpen: boolean }>`
  ${({ isOpen }) =>
    isOpen &&
    css`
      body {
        overflow: hidden !important;
      }
    `}
`;
